module.exports = __webpack_public_path__ + "static/media/choose-your-element.345bdcf9.png";